import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrossSvgComponent } from './cross.component';



@NgModule({
  declarations: [
    CrossSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    CrossSvgComponent
  ]
})
export class CrossSvgModule { }
